module.exports = __webpack_public_path__ + "static/media/chat1.29beaf41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/web_apps/chat1.jpg
// module id = 124
// module chunks = 0